'use client';

import { signIn } from 'next-auth/react';
import Image from 'next/image';
import { useSearchParams } from 'next/navigation';
import { Suspense } from 'react';

// Separate component that uses useSearchParams
function LoginButton() {
  const searchParams = useSearchParams();
  const callbackUrl = searchParams.get('callbackUrl') || '/';

  return (
    <button
      onClick={() => signIn('microsoft-entra-id', { callbackUrl })}
      className="w-full p-2 text-white bg-blue-600 rounded hover:bg-blue-700"
    >
      Sign in with Microsoft
    </button>
  );
}

export default function Login() {
  return (
    <div className="flex items-center justify-center min-h-screen bg-white">
      <div className="w-full max-w-xs p-8">
        <Image 
          src="/TirecoAI.png" 
          alt="TirecoAI Logo" 
          width={150}
          height={150}
          className="w-[150px] mx-auto mb-8"
          priority
        />
        <Suspense fallback={
          <button className="w-full p-2 text-white bg-blue-400 rounded" disabled>
            Loading...
          </button>
        }>
          <LoginButton />
        </Suspense>
      </div>
    </div>
  );
} 